import React, { memo } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CONST_RETAIL_APPLICANT } from 'shared/constants';
import CheckIcons from 'assets/icons/check-icon.svg';
import './StatusBoxWithCheckmark.scss';

const {
  SELECT_BOX: { REWORK },
  STATUS: {
    PREPARING_AGREEMENT, AGREEMENT_READY, AGREEMENT_SIGNED, AGREEMENT_GENERATED,
  },
} = CONST_RETAIL_APPLICANT;

interface Props {
  title?: string,
  status?: string,
  statusDetail?: any,
  isWaiting?: boolean,
}
/**
 * @param init <StatusBoxWithCheckmark status="Preparing agreement" statusDetail="Signed by client on" />
 * @param isWaiting <StatusBoxWithCheckmark isWaiting />
 */

const StatusBoxWithCheckmark:React.FC<Props> = memo(({
  status = null,
  isWaiting = false, statusDetail = null,
}) => {
  const classes = classNames({
    StatusBoxWithCheckmark: true,
    'StatusBoxWithCheckmark--preparing': !isWaiting && status && (status === AGREEMENT_SIGNED
    || status === AGREEMENT_GENERATED || status === AGREEMENT_READY),
    'StatusBoxWithCheckmark--ready': !isWaiting && status !== null && (status === PREPARING_AGREEMENT),
    'StatusBoxWithCheckmark--rework': !isWaiting && status !== null && status === REWORK,
    'StatusBoxWithCheckmark--waiting': isWaiting,
  });
  // console.log('status', status);
  return (
    <div className={classes}>
      <div className="StatusBoxWithCheckmark__body">
        <p className="StatusBoxWithCheckmark__body__image">
          {!isWaiting ? <img src={CheckIcons} alt="icon" /> : ''}
        </p>
        <p className="StatusBoxWithCheckmark__body__status">
          {isWaiting ? (
            <FormattedMessage
              key="2"
              id="manageApplication.waitingForClientToSign"
              values={{
                span: (...chunks) => <span>{chunks}</span>,
              }}
            />
          ) : (status) || null}
        </p>
      </div>
      {!isWaiting && statusDetail !== null && (
      <div className="StatusBoxWithCheckmark__date">
        {statusDetail}
      </div>
      )}
    </div>
  );
});

export default StatusBoxWithCheckmark;
